__turbopack_context__.v({
  "exploreSimilarEventsButton": "ExploreSimilarEventsButton-module-scss-module__mseguG__exploreSimilarEventsButton",
});
